(function () {
  angular
    .module("akitabox.building.list")
    .controller("BuildingsListController", BuildingsListController);

  /* @ngInject */
  function BuildingsListController(
    // Angular
    $scope,
    $state,
    $location,
    // URL parameters
    query,
    // Services
    BuildingService,
    OrganizationService
  ) {
    var self = this;

    var filter = BuildingService.getMyListFilter() || {};

    // Attributes
    self.searchText = null;
    self.searchOpen = false;
    self.buildings = null;
    self.loading = true;
    self.organization = OrganizationService.getCurrent();

    // Functions
    self.filterBuildings = filterBuildings;
    self.goToCreateWorkOrder = goToCreateWorkOrder;
    self.goToServiceRequestCreate = goToServiceRequestCreate;

    init();

    function init() {
      // Initialize search. Default to querystring, then cached filter
      self.searchText = query ? query : filter.q;
      self.searchOpen = !angular.isEmpty(self.searchText);

      BuildingService.getAllByOrganization(self.organization._id)
        .then(function (buildings) {
          self.buildings = buildings;
        })
        .finally(function () {
          self.loading = false;
        });

      // Change search param whenever search text changes
      $scope.$watch("vm.searchText", angular.debounce(onSearchChangeText, 500));
    }

    function onSearchChangeText(text) {
      $location.search("q", text);
      BuildingService.setMyListFilter({ q: text });
    }

    function goToCreateWorkOrder() {
      $state.go("app.workOrders.create");
    }

    function goToServiceRequestCreate() {
      $state.go("app.serviceRequests.create");
    }

    function filterBuildings(building) {
      if (angular.isEmpty(building)) {
        return false;
      } else if (!self.searchText) {
        return true;
      }

      var text = new RegExp(self.searchText, "i");
      var a = [
        "name",
        "description",
        "emergency_contact_name",
        "emergency_contact_phone",
        "address",
        "address_2",
        "city",
        "state",
        "postal_code",
      ];
      var matches = false;

      function check(key) {
        var value = building[key];
        matches =
          matches || (!angular.isEmpty(value) && value.match(text) !== null);
      }

      a.forEach(check);

      return matches;
    }
  }
})();
